import type { ReactNode } from 'react';
import { cn } from '@shared/lib/cn';

type Tone = 'positive' | 'warning' | 'neutral';

/**
 * Soft-filled pill. The label is always the meaning — the tint only reinforces
 * it — so a colour is never the sole carrier of information.
 */
const TONES: Record<Tone, string> = {
  positive: 'bg-periscope-100 text-periscope-800',
  warning: 'bg-amber-100 text-amber-800',
  neutral: 'bg-slate-200 text-slate-600',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
